import { NETWORK } from '@shared/utils/constant'
import { LocalStorage } from '@injectivelabs/utils/storage'
import { localStorage } from '@/app/services/localStorage'

// Clear up old local storage keys
export default defineNuxtPlugin(() => {
  const { $onError } = useNuxtApp()

  const MAX_LIMIT_OLD = 15
  const MAX_LIMIT = 10

  if (localStorage.has('storageCleaned')) {
    return
  }

  try {
    for (let i = 0; i <= MAX_LIMIT_OLD; i++) {
      const localStorageByIndex = new LocalStorage(
        `inj-dex-v${i}-${NETWORK}-${process.env.VITE_ENV || 'mainnet'}`
      )

      localStorageByIndex.clear()
    }

    for (let i = 0; i < MAX_LIMIT; i++) {
      const localStorageByIndex = new LocalStorage(`inj-helix-v${i}-${NETWORK}`)

      localStorageByIndex.clear()
    }

    localStorage.set('storageCleaned', 'true')
  } catch (error) {
    $onError(error)
  }
})
